export default class Colors {
  public static readonly PRIMARY = '#D03805';
  public static readonly IOWA_BLUE = '#2F5E8C';
}
